import { Breadcrumbs, ContactForm } from "@/components/features/requestForServices";
import Footer from "../../components/common/layout/Footer";
import SEO from "@/components/common/seo/seo";

export default function RequestForServices() {
    return(
        <div>
            <SEO
                title="Request for Services - SAN micron"
                description="Take the first step towards transforming your business with SAN micron's expert IT services. Fill out our request form to connect with our team and explore tailored solutions that meet your unique needs."
            />
           <Breadcrumbs />
           <div className="container text-center max-w-4xl mt-12 mb-8">
                <p className="text-textColor md:text-lg">
                    We’ve sparked growth and meaningful change across various industries, and we’re eager to continue building on your trust. Share a little about yourself, and let’s get started.
                </p>
            </div>
           <ContactForm />
            <div className="abstract-bg">
                 {/* <FAQ /> */}
            </div>
            <Footer />
        </div>
    );
}